export default "__VITE_ASSET__BwO5v9jO__"